import { makeStyles } from '@material-ui/core/styles';
import Table from 'components/CncUI/Table';
import Priority from '../Priority';
import EnumHelper from 'utilities/enumHelper';

const useStyles = makeStyles(({ palette }) => ({
  empty: {
    '& .cncui-table-cell': {
      textAlign: 'center',
      height: '5em',
      fontStyle: 'italic',
      color: palette.cncUI.default.primary,
    },
  },
}));

export const AccountsTable = ({ mappings, directDeposits, setPaperless }) => {
  const classes = useStyles();
  const multiple = true;
  const key = prop => `DirectDeposit-InfoPanel-${prop}`;
  const header = (
    <Table.Head>
      <Table.Row>
        {[
          multiple ? 'Priority' : null,
          'Bank Name',
          'Account Type',
          'Routing Number',
          'Account Number',
          directDeposits.length > 1 ? 'Split Amount' : 'Amount',
        ]
          .filter(Boolean)
          .map(name => (
            <Table.Cell key={key(`TableHeader-${name}`)}>{name}</Table.Cell>
          ))}
      </Table.Row>
    </Table.Head>
  );

  const rows = directDeposits.map((item, index) => {
    item.isPaperless && setPaperless(true);
    const isLast = index === directDeposits.length - 1;
    const total = directDeposits.length;
    const amount = isLast
      ? total === 1
        ? 'Full Amount'
        : 'Remainder'
      : item.flatAmount
      ? `$${item.flatAmount.toFixed(2)}`
      : `${parseInt(item.splitPercentage, 10)}%`;
    return (
      <Table.Row key={key(`TableRow-${index}`)}>
        {multiple && (
          <Table.Cell align="center">
            <Priority>{index + 1}</Priority>
          </Table.Cell>
        )}
        <Table.Cell>{item.bankName || ''}</Table.Cell>
        <Table.Cell>
          {EnumHelper.valueToOptionLabel(
            mappings.bankAccountTypes,
            item.bankAccountType,
          ).replace(' Account', '')}
        </Table.Cell>
        <Table.Cell>{item.routingNumber}</Table.Cell>
        <Table.Cell>{item.bankAccountNumber}</Table.Cell>
        <Table.Cell>{amount}</Table.Cell>
      </Table.Row>
    );
  });
  return (
    <Table>
      {header}
      <Table.Body>
        {(rows || []).length ? (
          rows
        ) : (
          <Table.Row className={classes.empty}>
            <Table.Cell align="center" colSpan={5}>
              No bank account added yet
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};

export default AccountsTable;
